import React, { useMemo } from "react";
import { useTranslation } from "../../i18n/I18nContext";
import { levelKey } from "../../utils/classesLabels";

const BAR_COLORS = ["#487FFF", "#FF9F29", "#45B369", "#8E5FE4", "#F1416C"];

const RegistrationsByCourse = ({ dashboardData, loading }) => {
  const { t } = useTranslation();
  const courses = useMemo(() => {
    const registrationsByCourse = (dashboardData && dashboardData.registrationsByCourse) || [];
    const total = registrationsByCourse.reduce(
      (sum, entry) => sum + parseInt(entry.count || 0, 10),
      0,
    );
    return registrationsByCourse
      .map((entry) => {
        const count = parseInt(entry.count || 0, 10);
        return {
          label: entry.course?.description || "-",
          count,
          percentage: total > 0 ? (count * 100) / total : 0,
        };
      })
      .sort((a, b) => b.count - a.count)
      .slice(0, 10);
  }, [dashboardData]);

  return (
    <div className='col-xxl-12'>
      <div className='card h-100 radius-8 border-0'>
        <div className='card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between'>
          <h6 className='mb-2 fw-bold text-lg'>{t(levelKey('dashboard.registrationsByCourse.title'))}</h6>
        </div>
        <div className='card-body p-24'>
          {loading && <span className='text-secondary-light'>{t('dashboard.loading')}</span>}
          {!loading && courses.length === 0 && (
            <span className='text-secondary-light'>{t('dashboard.registrations.empty')}</span>
          )}
          <div className='d-flex flex-column gap-20'>
            {courses.map((course, i) => (
              <div key={course.label}>
                <div className='d-flex align-items-center justify-content-between mb-8'>
                  <span className='text-sm text-secondary-light fw-medium'>
                    {course.label}{" "}
                    <span className='text-primary-light fw-semibold'>{course.count}</span>
                  </span>
                  <span className='text-xs text-secondary-light fw-semibold'>
                    {course.percentage.toFixed(1)}%
                  </span>
                </div>
                <div
                  className='progress progress-sm rounded-pill'
                  role='progressbar'
                  aria-valuenow={course.percentage}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >
                  <div
                    className='progress-bar rounded-pill'
                    style={{
                      width: `${course.percentage}%`,
                      backgroundColor: BAR_COLORS[i % BAR_COLORS.length],
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationsByCourse;
